import React, { useState } from "react";

const TriageAssessment = ({ data, updateData }) => {
  const [formState, setFormState] = useState(data || {});

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...formState, [name]: value };
    setFormState(updatedForm);
    updateData(updatedForm);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Triage Assessment Data", formState);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label
            htmlFor="bloodPressure"
            className="block text-gray-700 font-medium"
          >
            Blood Pressure (mmHg)
          </label>
          <input
            type="text"
            id="bloodPressure"
            name="bloodPressure"
            value={formState.bloodPressure || ""}
            onChange={handleChange}
            placeholder="Enter blood pressure"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            htmlFor="heartRate"
            className="block text-gray-700 font-medium"
          >
            Heart Rate (bpm)
          </label>
          <input
            type="number"
            id="heartRate"
            name="heartRate"
            value={formState.heartRate || ""}
            onChange={handleChange}
            placeholder="Enter heart rate"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            htmlFor="initialDiagnosis"
            className="block text-gray-700 font-medium"
          >
            Initial Diagnosis
          </label>
          <textarea
            id="initialDiagnosis"
            name="initialDiagnosis"
            value={formState.initialDiagnosis || ""}
            onChange={handleChange}
            placeholder="Enter initial diagnosis"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
    </form>
  );
};

export default TriageAssessment;
